import { useCallback, useMemo, useRef } from 'react';
import {
  NavigationContainer,
  NavigationContainerProps,
  DefaultTheme,
  DocumentTitleOptions,
} from '@react-navigation/native';
import { useTheme } from '@betty/moonlight';
import { trackScreenView, useDispatch } from '@betty/toolkit/state';
import { navigationIntegration } from '@betty/toolkit/logging';
import navigationRef from './navigationRef';

const documentTitle: DocumentTitleOptions = {
  enabled: false,
  formatter: () => '',
};

function ThemedNavigationContainer(props: NavigationContainerProps) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const routeNameRef = useRef<string | undefined>();
  const navigationTheme = useMemo(
    () => ({
      ...DefaultTheme,
      dark: true,
      colors: {
        primary: theme.color.darkSurfacePrimary,
        background: theme.color.screenBackground,
        card: theme.color.screenBackground,
        text: theme.color.darkSurfacePrimary,
        border: theme.color.borderPrimary,
        notification: theme.color.darkSurfacePrimary,
      },
    }),
    [theme],
  );

  const onStateChange = useCallback(() => {
    const previousRouteName = routeNameRef.current;
    const currentRoute = navigationRef.getCurrentRoute();
    const currentRouteName = currentRoute?.name;

    if (currentRouteName && previousRouteName !== currentRouteName) {
      dispatch(
        trackScreenView({
          screenName: currentRouteName,
        }),
      );
    }

    // Save the current route name for later comparison
    routeNameRef.current = currentRouteName;
  }, [dispatch]);

  const onReady = useCallback(() => {
    navigationIntegration.registerNavigationContainer(navigationRef);
  }, []);

  return (
    <NavigationContainer
      ref={navigationRef}
      theme={navigationTheme}
      onStateChange={onStateChange}
      onReady={onReady}
      documentTitle={documentTitle}
      {...props}
    />
  );
}

export default ThemedNavigationContainer;
